import SankeyPlot from './SankeyPlot';

export default SankeyPlot;
